
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Select from "react-select";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import * as service from '../../../../services/service';

function AddEditItemDistribution() {
    const [state, setState] = useState({ quantity: '', officername: '' });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [designationData, setDesignationData] = useState([]);
    const [designationId, setDesignationId] = useState();
    const [userData, setUserData] = useState([]);
    const [userId, setUserId] = useState();
    const [officeData, setOfficeData] = useState([]);
    const [officeId, setOfficeId] = useState();
    const [itemCategoryData, setItemCategoryData] = useState([]);
    const [itemCategoryId, setItemCategoryId] = useState();
    const [itemData, setItemData] = useState([]);
    const [itemDataForBalance, setItemDataForBalance] = useState([]);
    const [availableBalance, setAvailableBalance] = useState();
    const [itemId, setItemId] = useState();
    const [unitData, setUnitData] = useState([]);
    const [unit, setUnit] = useState();
    const [distributionDate, setDistributionDate] = useState(new Date());

    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const navigate = useNavigate();
    const params = useParams();

    const getDesignations = () => {
        fetch(
            service.DESIGNATION_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.designationId, label: item.designation }));
                const sel = ({ value: "0", label: "Select Designation" });
                data2.unshift(sel);
                setDesignationData(data2);
                setDesignationId(sel);
            });
    };

    const getUsers = (id) => {
        fetch(
            service.GET_USERS_BY_DESIGNATION_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    DesignationId: id,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.userId, label: item.userName }));
                const sel = ({ value: "0", label: "Select User" });
                data2.unshift(sel);
                setUserData(data2);
                setUserId(sel);
            });
    };

    const getOffices = () => {
        fetch(
            service.OFFICE_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.officeId, label: item.officeName }));
                const sel = ({ value: "0", label: "Select Office" });
                data2.unshift(sel);
                setOfficeData(data2);
                setOfficeId(sel);
            });
    };

    const getItemCategory = () => {
        fetch(
            service.ITEM_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.itemCategoryId, label: item.itemCategory }));
                setItemCategoryData(data2);
            });
    };
    const getItem = (cat) => {
        fetch(
            service.ITEM_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ItemCategoryId: cat,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                setItemDataForBalance(result);
                const data2 = result.map((item) => ({ value: item.itemId, label: item.item }));
                setItemData(data2);
            });
    };
    const getUnit = () => {
        fetch(
            service.UNIT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.unitId, label: item.unit }));
                setUnitData(data2);
            });
    };

    const getUnitByItem = (itmId) => {
        fetch(
            service.GET_UNIT_BY_ITEM,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ItemId: itmId,
                    ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = ({ value: result.unitId, label: result.unit });
                setUnit(data2);
            });
    };
    const getDetailsById = () => {
        setLoading(true);
        const errs = {};
        if (params.id > 0) {
            fetch(
                service.GET_ITEM_DISTRIBUTION_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DistributionId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setState({
                            ...state, quantity: result.quantity, officername: result.officerName
                        });
                        setDistributionDate(new Date(result.distributionDate));
                        const cat = ({ label: result.itemCategory, value: result.itemCategoryId });
                        setItemCategoryId(cat);

                        getItem(result.itemCategoryId);
                        const item = ({ label: result.item, value: result.itemId });
                        setItemId(item);

                        const ut = ({ label: result.unit, value: result.unitId });
                        setUnit(ut);

                        const des = ({ label: result.designation, value: result.designationId });
                        const usr = ({ label: result.userName, value: result.userId });
                        if (result.userName !== "") {
                            setUserId(usr);
                            setDesignationId(des);
                        }

                        const ofc = ({ label: result.officeName, value: result.officeId });
                        if (result.officeName !== "") {
                            setOfficeId(ofc);
                        }
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        getItemCategory();
        getUnit();
        getDesignations();
        getUsers(0);
        getOffices();
        if (params.id > 0) {
            getDetailsById();
        }
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!distributionDate) {
            isValid = false;
            errs[".distributionDate"] = "Please enter distribution date";
        }
        if (!state.quantity) {
            isValid = false;
            errs[".quantity"] = "Please enter quantity";
        }
        if (!itemCategoryId) {
            isValid = false;
            errs[".itemCategory"] = "Please select item category";
        }
        if (!itemId) {
            isValid = false;
            errs[".item"] = "Please select item";
        }
        if (!userId && !officeId) {
            isValid = false;
            errs[".user"] = "Please select either user or office";
        }
        else if (userId.value === '0' && officeId.value === '0') {
            isValid = false;
            errs[".user"] = "Please select either user or office";
        }
        else if (userId.value !== '0' && officeId.value !== '0') {
            isValid = false;
            errs[".user"] = "Please select either user or office";
        }
        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };
    const itemCategoryChangeHandler = (ev) => {
        setItemCategoryId(ev);
        getItem(ev.value);
    }
    const itemChangeHandler = (ev) => {
        setItemId(ev);
        getUnitByItem(ev.value);
        const bal = itemDataForBalance.find(x => x.itemId === ev.value).availableQuantity;
        setAvailableBalance(bal);
        console.log(itemDataForBalance);
    }
    // const unitChangeHandler = (ev) => {
    //     setUnit(ev);
    // }
    const designationChangeHandler = (ev) => {
        setDesignationId(ev);
        getUsers(ev.value);
    }
    const userChangeHandler = (ev) => {
        setUserId(ev);
    }
    const officeChangeHandler = (ev) => {
        setOfficeId(ev);
    }
    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        if (validate()) {
            fetch(
                service.ADD_UPDATE_ITEM_DISTRIBUTION,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        DistributionId: params.id ? params.id : null,
                        DistributionDate: moment(distributionDate).format("MM/DD/YYYY"),
                        ItemCategoryId: itemCategoryId.value,
                        ItemId: itemId.value,
                        Unit: unit.label,
                        Quantity: state.quantity,
                        UserId: userId.value,
                        OfficeId: officeId.value,
                        OfficerName: state.officername,
                        ClientId: JSON.parse(sessionStorage.getItem('userData')).clientId,
                        AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                        UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/stock/itemdistribution');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        navigate('/stock/itemdistribution');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <MDBox pt={4} pb={3} px={3} style={{ width: '90%' }}>
                                    <MDBox component="form" role="form">
                                        <TableContainer component={Paper} style={{ width: '98%', alignSelf: 'center', height: '500px' }}>
                                            <Table aria-label="simple table">
                                                <TableRow>
                                                    <TableCell>
                                                        <div style={{ fontSize: '12px' }}>
                                                            Distribution Date
                                                            <DatePicker
                                                                id="distributionDate"
                                                                selected={distributionDate}
                                                                onChange={date => setDistributionDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                tabIndex={0}
                                                            />
                                                        </div>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".distributionDate"]}</div>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell width="50%">
                                                        <MDBox mb={2}>
                                                            <div style={{ fontSize: '12px' }}>
                                                                <Select
                                                                    options={itemCategoryData}
                                                                    name="itemCategory"
                                                                    value={itemCategoryId}
                                                                    onChange={itemCategoryChangeHandler}
                                                                    isSearchable
                                                                    styles={selectStyles}
                                                                    placeholder="Select Item Category"
                                                                />
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".itemCategory"]}</div>
                                                        </MDBox>
                                                    </TableCell>
                                                    <TableCell>
                                                        <MDBox mb={2}>
                                                            <div style={{ fontSize: '12px' }}>
                                                                <Select
                                                                    options={itemData}
                                                                    name="item"
                                                                    value={itemId}
                                                                    onChange={itemChangeHandler}
                                                                    isSearchable
                                                                    styles={selectStyles}
                                                                    placeholder="Select Item"
                                                                />
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".item"]}</div>
                                                        </MDBox>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>
                                                        <MDBox mb={2}>
                                                            <div style={{ fontSize: '12px' }}>
                                                                <Select
                                                                    options={unitData}
                                                                    name="unit"
                                                                    value={unit}
                                                                    // onChange={unitChangeHandler}
                                                                    isSearchable
                                                                    styles={selectStyles}
                                                                    placeholder="Select Unit"
                                                                    isDisabled
                                                                />
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".unit"]}</div>
                                                        </MDBox>
                                                    </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <div style={{ fontSize: '12px' }}>
                                                                    Available Balance :  {availableBalance}
                                                                </div>
                                                            </MDBox>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <MDInput label="Quantity" fullWidth value={state.quantity || ''}
                                                                    name="quantity"
                                                                    onChange={changeHandler}
                                                                    id="quantity"
                                                                    required />
                                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".quantity"]}</div>
                                                            </MDBox>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <div style={{ fontSize: '12px' }}>
                                                                    <Select
                                                                        options={designationData}
                                                                        name="designation"
                                                                        value={designationId}
                                                                        onChange={designationChangeHandler}
                                                                        isSearchable
                                                                        styles={selectStyles}
                                                                        placeholder="Select Designation"
                                                                    />
                                                                </div>
                                                            </MDBox>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <div style={{ fontSize: '12px' }}>
                                                                    <Select
                                                                        options={userData}
                                                                        name="user"
                                                                        value={userId}
                                                                        onChange={userChangeHandler}
                                                                        isSearchable
                                                                        styles={selectStyles}
                                                                        placeholder="Select User"
                                                                    />
                                                                </div>
                                                            </MDBox>
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <div style={{ fontSize: '12px', fontWeight: 'bold' }}>OR</div>
                                                                <div style={{ fontSize: '12px' }}>
                                                                    <Select
                                                                        options={officeData}
                                                                        name="office"
                                                                        value={officeId}
                                                                        onChange={officeChangeHandler}
                                                                        isSearchable
                                                                        styles={selectStyles}
                                                                        placeholder="Select Office"
                                                                    />
                                                                </div>
                                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".user"]}</div>
                                                            </MDBox>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MDBox mb={2}>
                                                                <MDInput label="Name" fullWidth value={state.officername || ''}
                                                                    name="officername"
                                                                    onChange={changeHandler}
                                                                    id="officername"
                                                                    required />
                                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".officername"]}</div>
                                                            </MDBox>
                                                        </TableCell>
                                                    </TableRow>
                                            </Table>
                                        </TableContainer>
                                        <MDBox mt={4} mb={1} textAlign="center">
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    SAVE
                                                </MDButton>
                                            }
                                            {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddEditItemDistribution;